import script from "./RegisterForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegisterForm.vue?vue&type=script&setup=true&lang=ts"

import "./RegisterForm.vue?vue&type=style&index=0&id=4966899f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4966899f"]])

export default __exports__